import { getBatch, updateBatch } from 'services/axios/batch'

export const actions = {
  GET_BATCH: 'GET_BATCH',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  GET_ALL_BATCHES: 'GET_ALL_BATCHES',
  UPDATE_BATCH: 'UPDATE_BATCH',
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const getBatchesList = ({
  skip,
  limit,
  title,
  trainerId,
  processId,
  startDate,
  endDate,
}) => {
  return async (dispatch) => {
    const response = await getBatch({
      skip,
      limit,
      title,
      trainerId,
      processId,
      startDate,
      endDate,
    })

    dispatch({
      type: actions.GET_BATCH,
      payload: {
        batchList: response?.data?.data?.batchList,
        totalCount: response?.data?.data?.totalCount,
      },
    })
  }
}
export const getAllBatches = ({ skip, limit }) => {
  return async (dispatch) => {
    const response = await getBatch({
      skip,
      limit,
    })
    console.log('All Batches Response:', response)

    dispatch({
      type: actions.GET_ALL_BATCHES,
      payload: {
        batchList: response?.data?.data?.batchList,
      },
    })
  }
}

export const updateBatchAction = (id, data) => {
  return async (dispatch) => {
    const response = await updateBatch(id, data)
    const updatedBatch = response?.data?.data
    dispatch({
      type: actions.UPDATE_BATCH,
      payload: updatedBatch,
    })
  }
}
